import AppDispatcher from '../dispatcher/AppDispatcher';
import MoveMoneyPayeeConstants from '../constants/MoveMoneyPayeeConstants';

class MoveMoneyPayeeActionCreator {
  /*
      To raise view action to update the store and view
       @param {String} actionType		action type.
      @param {object} data		data passed to action type.
    */
  raise(actionType, data) {
    AppDispatcher.handleViewAction({
      actionType,
      data,
    });
  }

  /*
    To raise servcer action to call API and update the view and store
    @param {String} actionType		action type.
    @param {object} data		data passed to action type.
  */
  raiseServerAction(actionType, data) {
    AppDispatcher.handleServerAction({
      actionType,
      data,
    });
  }

  /*
    call add company service
  */
  getCompanyListFromName(value) {
    let reqPacket = {
      display_name: value,
    };
    this.raise(MoveMoneyPayeeConstants.MOVEMONEY_COMPANY_SEARCH, reqPacket);
  }

  /*
  call the srd verify service call
  @param {String} sortcode and account number value
  */
  verifySRDPayee(value) {
    this.raise(MoveMoneyPayeeConstants.MOVEMONEY_SRD_VERIFY, {
      scheme_name: 'SortCodeAccountNumber',
      identification: value,
    });
  }

  getCompanyListFromSortcode(sortcode, accnum) {
    let reqPacket = {
      sort_code: sortcode,
      account_number: accnum,
    };
    this.raise(MoveMoneyPayeeConstants.MOVEMONEY_COMPANY_SEARCH, reqPacket);
  }

  /*
  handle the success response for comapny service call
  @param {Object} response comapny success
  */
  handleCompanySearchServiceCall(response) {
    switch (response.code) {
      case 201:
        // raising action for add payee success
        this.raiseServerAction(
          MoveMoneyPayeeConstants.MOVEMONEY_COMPANY_DETAILS,
          response
        );
        break;
      case 409:
        // raising action for add payee failure
        this.raiseServerAction(
          MoveMoneyPayeeConstants.MOVEMONEY_COMPANY_FAILURE,
          response
        );
        break;
      default:
    }
  }

  /*
    handle response of newly added Company payee for succes/failure
    @param {Object} response		added Company payee response
  */
  handleAddCompanyPayeeServiceCall(response) {
    switch (response.code) {
      case 201:
        // raising action for add payee success
        this.raiseServerAction(
          MoveMoneyPayeeConstants.MOVEMONEY_ADD_COMPANY_SUCCESS,
          response
        );
        break;
      case 422:
        // raising action for add payee failure
        this.raiseServerAction(
          MoveMoneyPayeeConstants.MOVEMONEY_ADD_COMPANY_FAILURE,
          response
        );
        break;
      default:
    }
  }

  /*
  call add company payee service
  */
  addCompanyPayee(copPayload) {
    // raise action  for add Payee
    this.raise(
      MoveMoneyPayeeConstants.MOVEMONEY_ADD_COMPANY_PAYEE_SERVICECALL,
      copPayload
    );
  }

  /*
  update the value of passed name for add company payee
  @param {String} name		name of key
  @param {String} value		value of passed name
  */
  updateCompanyForm(valueObj) {
    // calling action to update the form value
    this.raiseServerAction(
      MoveMoneyPayeeConstants.MOVEMONEY_UPDATE_ADD_COMPANY_FORM,
      valueObj
    );
  }

  /*
    Navigate To WebTask base on taskId
    @param {String} taskId		navigation task Id
  */
  navigateToWebTask(taskId) {
    // PayeeActionCreator.raise(AppConstants.NAVIGATE_TO_WEB_TASK, { taskId });
  }

  /*
    handle the success response for list of payee service call
    @param {Object} response		payee success response
  */
  handlePayeesListSuccess(response) {
    AppDispatcher.handleServerAction({
      actionType: MoveMoneyPayeeConstants.MOVEMONEY_GET_FROM_PAYEES_SUCCESS,
      data: response,
    });
  }

  /*
    handle the success response for edit and payee service call
    @param {Object} response payee success
  */
  handlePayeeServiceCall(response) {
    AppDispatcher.handleServerAction({
      actionType: MoveMoneyPayeeConstants.MOVEMONEY_DELETE_PAYEE_FAILED,
      data: response,
    });
  }

  /*
    call the delete payee service
    @param {Object} deletePayeeRequestPacket		delete payee request
  */
  deletePayee(deletePayeeRequestPacket) {
    this.raise(
      MoveMoneyPayeeConstants.MOVEMONEY_DELETE_PAYEE_DETAILS,
      deletePayeeRequestPacket
    );
  }

  /*
    handle deleted payee success response
    @param {Object} response		deleted payee response
  */
  handleDeletePayeeSuccess(response) {
    //	PayeeActionCreator.getPayeeList();
    AppDispatcher.handleServerAction({
      actionType: MoveMoneyPayeeConstants.MOVEMONEY_DELETE_PAYEE_SUCCESS,
      data: response,
    });
  }

  /*
    update the value of passed name for Edit payee
    @param {String} name		name of key
    @param {String} value		value of passed name
  */
  updateEditForm(name, value) {
    this.raiseServerAction(
      MoveMoneyPayeeConstants.MOVEMONEY_UPDATE_EDIT_PAYEE_FORM,
      { name, value }
    );
  }

  // company manually is same as add payee
  updateCompanyFormManually(valueObj) {
    this.raise(
      MoveMoneyPayeeConstants.MOVEMONEY_UPDATE_ADD_COMPANY_MANUALLY,
      valueObj
    );
  }

  updateAllEditFiled(updateFields) {
    this.raiseServerAction(
      MoveMoneyPayeeConstants.MOVEMONEY_UPDATE_ALL_EDIT_FORM_VALUES,
      updateFields
    );
  }

  /**
   * Temporary approach to force sequential edits for some COP
   * related actions. Preferably we'd need to rewrite all retail/company
   * payee edit flows across `MoveMoneyFromToComponent` and `EditPayeePage` components.
   */
  editPayee(copPayload, enforceSequentialEdit = false) {
    this.raise(MoveMoneyPayeeConstants.MOVEMONEY_EDIT_PAYEE_SERVICECALL, {
      ...copPayload,
      enforceSequentialEdit,
    });
  }

  /*
  call add payee service
  */
  addPayee(copPayload) {
    // raise action  for add Payee
    this.raise(
      MoveMoneyPayeeConstants.MOVEMONEY_ADD_PAYEE_SERVICECALL,
      copPayload
    );
  }

  /*
    handle response of newly added payee for succes/failure
    @param {Object} response		added payee response
  */
  handleAddPayeeServiceCall(response) {
    switch (response.code) {
      case 201:
        // raising action for add payee success
        this.raiseServerAction(
          MoveMoneyPayeeConstants.MOVEMONEY_ADD_PAYEE_SUCCESS,
          response
        );
        break;
      case 422:
        // raising action for add payee failure
        this.raiseServerAction(
          MoveMoneyPayeeConstants.MOVEMONEY_ADD_PAYEE_FAILURE,
          response
        );
        break;
      default:
    }
  }

  handlePutRetailPayeeSuccess(response) {
    this.raiseServerAction(
      MoveMoneyPayeeConstants.MOVEMONEY_PUT_PAYEE_SUCCESS,
      response
    );
  }

  handlePutRetailPayeeError(response) {
    this.raiseServerAction(
      MoveMoneyPayeeConstants.MOVEMONEY_PUT_PAYEE_ERROR,
      response
    );
  }

  storeUnauthorisedBeneficiaryDetails(data) {
    this.raise(
      MoveMoneyPayeeConstants.MOVEMONEY_STORE_UNAUTHORISED_BENEFICIARY_DETAILS,
      data
    );
  }

  resetData() {
    this.raise(MoveMoneyPayeeConstants.MOVEMONEY_RESET_PAYEE_DETAILS, {});
  }

  savePayeeInStore(data) {
    this.raise(MoveMoneyPayeeConstants.MOVEMONEY_SAVE_ADD_PAYEE_DETAILS, data);
  }

  handleSRDVerificationServiceCall(value) {
    this.raise(MoveMoneyPayeeConstants.MOVEMONEY_SRD_VERIFY, {
      scheme_name: 'SortCodeAccountNumber',
      identification: value,
    });
  }

  handleSrdDetailsSuccess(response) {
    this.raise(MoveMoneyPayeeConstants.MOVEMONEY_SRD_SUCCESS, response);
  }

  handleSrdDetailsFailure(errors) {
    this.raise(MoveMoneyPayeeConstants.MOVEMONEY_SRD_FAILURE, errors);
  }
}

export default new MoveMoneyPayeeActionCreator();
